import React, { useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function VoiceAi() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="sub-banner-section-outer">
        <Navigation />
        <section className="sub-banner-section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <div className="sub-banner-text">
                  <h1 className="text-white mb-lg-4 mb-3">
                    Transforming the Future of the QSR Industry with Voice AI
                  </h1>
                  <div className="breadcrum">
                    <span className="font-weight-normal d-inline-block text-white">
                      This capability enables T-Sourcings AI to efficiently
                      process thousands of orders for numerous customers across
                      various locations, all seamlessly integrated into your
                      restaurant’s POS system.
                    </span>
                    <div className="about-service-section-btn-outer d-lg-block d-none">
                      <Link
                        to="/book-a-demo"
                        className="d-inline-block hover-effect"
                        href="about.html"
                      >
                        Book a demo
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="about-service-section ">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12">
              <div
                className="about-service-section-img-content position-relative wow bounceIn"
                data-wow-duration="2s"
              >
                <figure className="about-service-section-shape-img-2 mb-0 position-absolute">
                  <img
                    className="img-fluid"
                    src="assets/images/about-service-section-shape-img-2.png"
                    alt=""
                  />
                </figure>
                <figure className="about-service-section-main-img mb-0 position-relative">
                  <img
                    className="img-fluid"
                    src="assets/images/about-service-section-main-img.png"
                    alt=""
                  />
                </figure>
                <div className="counter-box position-absolute">
                  <figure className="plus-icon float-left mb-0">
                    <img
                      className="img-fluid"
                      src="assets/images/client-icon.png"
                      alt=""
                    />
                  </figure>
                  <span className="number count d-inline-block">1675</span>
                  <span className="suffix d-inline-block">+</span>
                  <span className="customer d-block">Trusted Clients</span>
                </div>
                <figure className="about-service-section-shape-img-3 mb-0 position-absolute">
                  <img
                    className="img-fluid"
                    src="assets/images/about-service-section-shape-img-3.png"
                    alt=""
                  />
                </figure>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12">
              <div className="about-service-section-text position-relative">
                <figure className="about-service-section-shape-img-1 mb-0 position-absolute">
                  <img
                    className="img-fluid"
                    src="assets/images/about-service-section-shape-img-1.png"
                    alt=""
                  />
                </figure>
                <h2 className="mb-lg-4 mb-md-3 mb-2">
                  Best Call Center Service For Your Business
                </h2>
                <p>
                  SD is excited to launch AI-driven voice ordering solutions for
                  the QSR Industry. This expansion builds upon its current
                  system that already utilizes highly-trained, top-notch call
                  agents. The aim is to enhance restaurant operations by
                  introducing cost-effective innovations. These advancements
                  could empower QSR stores to boost their Ticket Sales by
                  attending to all calls and exploring additional revenue
                  streams. Consequently, customers can expect a seamless and
                  exceptional experience from start to finish.
                </p>

                <div className="about-service-section-btn-outer d-lg-block d-none">
                  <a className="d-inline-block hover-effect" href="about.html">
                    Schedule a meeting
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="customer-base-section about-page-customer-base-section my-5">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12 order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2">
              <div
                className="customer-base-section-text position-relative wow bounceIn"
                data-wow-duration="2s"
              >
                <h2 className="mb-lg-4 mb-md-3 mb-2">How Does It Work</h2>
                <p>
                  Voice AI is Revolutionizing the Restaurant Industry. Our
                  state-of-the-art conversational AI system helps you to
                  scale-up by efficiently handling your Drive-Thru and Phone
                  Orders with exceptional precision. We can be anywhere your
                  customer engages with you, due to our Multi-channel
                  capabilities. It’s time to delight your customers and
                  restaurant employees.
                </p>
              </div>
            </div>
            <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 order-xl-2 order-lg-2 order-md-2 order-sm-1 order-1">
              <div className="customer-base-section-img-content position-relative">
                <figure className="customer-base-section-shape-img-2 mb-0 position-absolute">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-shape-img-2.png"
                    alt=""
                  />
                </figure>
                <figure className="customer-img-1 position-absolute mb-0">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-customer-img-1.png"
                    alt=""
                  />
                </figure>
                <figure className="customer-img-2 position-absolute mb-0">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-customer-img-2.png"
                    alt=""
                  />
                </figure>
                <figure className="customer-base-section-main-img mb-0 text-right position-relative">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-main-img.png"
                    alt=""
                  />
                </figure>
                <figure className="customer-img-3 position-absolute mb-0">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-customer-img-3.png"
                    alt=""
                  />
                </figure>
                <figure className="customer-img-4 position-absolute mb-0">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-customer-img-4.png"
                    alt=""
                  />
                </figure>
                <figure className="customer-img-5 position-absolute mb-0">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-customer-img-5.png"
                    alt=""
                  />
                </figure>
                <div className="counter-box position-absolute">
                  <figure className="plus-icon float-left mb-0">
                    <img
                      className="img-fluid"
                      src="/assets/images/plus-icon.png"
                      alt=""
                    />
                  </figure>
                  <span className="number count d-inline-block">1281</span>
                  <span className="suffix d-inline-block">+</span>
                  <span className="customer d-block">New Customers</span>
                </div>
                <figure className="customer-base-section-shape-img-3 mb-0 position-absolute">
                  <img
                    className="img-fluid"
                    src="/assets/images/customer-base-section-shape-img-3.png"
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="divider"></div>

      <section className="solutions-section py-5">
        <div className="container">
          <div className="solutions-section-inner text-md-left text-center">
            <div className="row">
              <h2 className="mb-lg-4 mb-2">Here’s how we make it happen</h2>
            </div>
          </div>
          <div className="row wow slideinLeft" data-wow-duration="2s">
            <div className="col-md-4 col-sm-6 mb-md-0 mb-4 text-md-left text-center">
              <div className="solutions-section-plan-box hover-effect">
                <div className="row">
                  <div className="col-lg-3 col-12">
                    <figure>
                      <img
                        src="assets/images/solution-section-plan-box-img-1.png"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div className="col-lg-9 col-12">
                    <h4>Natural Dialogue</h4>
                  </div>
                  <p className="text-size-16 mb-0">
                    Your customers will have a clear conversation with our AI,
                    be understood, be able to interrupt, and receive only
                    information relevant to them, engaging them through a
                    secure, easy to understand conversation. Our AI solution
                    learns about your customers preferences, and stores their
                    data so that future dialogues are more personalized and
                    quick. Our learning AI model will eventually be able to
                    handle Multilingual capabilities.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 mb-md-0 mb-4 text-md-left text-center">
              <div className="solutions-section-plan-box hover-effect">
                <div className="row">
                  <div className="col-lg-3 col-12">
                    <figure>
                      <img
                        src="assets/images/solution-section-plan-box-img-2.png"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div className="col-lg-9 col-12">
                    <h4>Immediate Processing</h4>
                  </div>
                  <p className="text-size-16 mb-0">
                    Because of crisp personalized AI dialogues and due to our
                    Cloud-based model, that works flawlessly with your POS,
                    expect order fulfillment in the quickest and most accurate
                    way! Your store will be instantly informed about orders and
                    also store-related calls, if and when they’re needed. Our AI
                    solution is flawlessly integrated with our Contact Center
                    capabilities, helping you to customize our solution to fit
                    your needs!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 text-md-left text-center">
              <div className="solutions-section-plan-box hover-effect">
                <div className="row">
                  <div className="col-lg-3 col-12">
                    <figure>
                      <img
                        src="assets/images/solution-section-plan-box-img-3.png"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div className="col-lg-9 col-12">
                    <h4>Order Fulfillment</h4>
                  </div>
                  <p className="text-size-16 mb-0">
                    Has never been easier for your business! Improvement in
                    customer satisfaction, return customers and effective
                    upselling, may require your in-store team to be ready to see
                    a surge in order fulfillment. Our service will handle your
                    order calls, while your staff can focus on what matters
                    most, be it meal preparation, delivery & serving your
                    dine-in customers even better!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="customer-base-section about-page-customer-base-section contact-form-section my-5">
        <div class="container">
          <div class=" order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2 text-md-left text-center">
            <div class="customer-base-section-text position-relative text-center">
              <h2 class="mb-lg-4 mb-md-3 mb-2">
                If you’re ready for a Demo, want to learn more or would like to
                discuss your unique requirements with our team, fill our form
                below:
              </h2>
              <p>
                Your email address will not be published. Required fields are
                marked *
              </p>
              <div class="contact-form">
                <form method="POST" action="contact-form.php">
                  <div className="row">
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="First Name:"
                          name="name"
                          id="name"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Last Name:"
                          name="email"
                          id="email"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      {" "}
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Your Email:"
                          name="email"
                          id="email"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Phone Number:"
                          name="name"
                          id="name"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      {" "}
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Company:"
                          name="email"
                          id="email"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <textarea
                      class="form-control textarea"
                      placeholder="Add Comment:"
                      rows="3"
                      name="comments"
                      id="comments"
                    ></textarea>
                  </div>
                  <div class="submitform-button">
                    <button
                      type="submit"
                      id="submit"
                      class="submitform-btn hover-effect d-block"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default VoiceAi;
